import { ThemeProvider } from '@emotion/react';
import { CssBaseline } from '@mui/material';
import { observer } from 'mobx-react';
import { AuthProvider } from 'react-oidc-context';
import App from '../App';
import { cognitoAuthConfig } from '../config/aws';
import authStore from '../store/Auth';
import { createAppTheme } from '../styles/styles';
import BaseCofirmDialog from './BaseConfirmDialog';
import Notification from './Notifications';

const AppTheme = observer(() => {
  return (
    <ThemeProvider theme={createAppTheme(authStore?.user?.isAuthenticated)}>
      <CssBaseline />
      <AuthProvider {...cognitoAuthConfig}>
        <Notification />
        <BaseCofirmDialog />
        <App />
      </AuthProvider>
    </ThemeProvider>
  );
});

export default AppTheme;
